var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_716_1589)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0183 24C18.6558 24 24.0365 18.6274 24.0365 12C24.0365 5.37258 18.6558 0 12.0183 0C5.38077 0 0 5.37258 0 12C0 18.6274 5.38077 24 12.0183 24Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0182 23.6353C18.5549 23.6353 23.8539 18.3443 23.8539 11.8176C23.8539 5.29093 18.5549 0 12.0182 0C5.48161 0 0.182617 5.29093 0.182617 11.8176C0.182617 18.3443 5.48161 23.6353 12.0182 23.6353Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_716_1589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6897 10.4316H12.2011V13.5319H16.5116C16.1098 15.5015 14.4294 16.6322 12.2011 16.6322C9.57094 16.6322 7.45222 14.5167 7.45222 11.8905C7.45222 9.26439 9.57094 7.14889 12.2011 7.14889C13.3335 7.14889 14.3563 7.55011 15.16 8.20665L17.4979 5.87229C16.0732 4.63217 14.2467 3.86621 12.2011 3.86621C7.74446 3.86621 4.16455 7.44068 4.16455 11.8905C4.16455 16.3404 7.74446 19.9148 12.2011 19.9148C16.2193 19.9148 19.8723 16.9969 19.8723 11.8905C19.8723 11.4164 19.7993 10.9057 19.6897 10.4316Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_716_1589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43408 16.6322V7.14893L9.64413 11.8906L3.43408 16.6322Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_716_1589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6897 10.4316H12.2011V13.5319H16.5116C16.1098 15.5015 14.4294 16.6322 12.2011 16.6322C9.57094 16.6322 7.45222 14.5167 7.45222 11.8905C7.45222 9.26439 9.57094 7.14889 12.2011 7.14889C13.3335 7.14889 14.3563 7.55011 15.16 8.20665L17.4979 5.87229C16.0732 4.63217 14.2467 3.86621 12.2011 3.86621C7.74446 3.86621 4.16455 7.44068 4.16455 11.8905C4.16455 16.3404 7.74446 19.9148 12.2011 19.9148C16.2193 19.9148 19.8723 16.9969 19.8723 11.8905C19.8723 11.4164 19.7993 10.9057 19.6897 10.4316Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_716_1589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43408 7.14888L9.64413 11.8905L12.2012 9.6656L20.9683 8.2431V3.13672H3.43408V7.14888Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_716_1589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6897 10.4316H12.2011V13.5319H16.5116C16.1098 15.5015 14.4294 16.6322 12.2011 16.6322C9.57094 16.6322 7.45222 14.5167 7.45222 11.8905C7.45222 9.26439 9.57094 7.14889 12.2011 7.14889C13.3335 7.14889 14.3563 7.55011 15.16 8.20665L17.4979 5.87229C16.0732 4.63217 14.2467 3.86621 12.2011 3.86621C7.74446 3.86621 4.16455 7.44068 4.16455 11.8905C4.16455 16.3404 7.74446 19.9148 12.2011 19.9148C16.2193 19.9148 19.8723 16.9969 19.8723 11.8905C19.8723 11.4164 19.7993 10.9057 19.6897 10.4316Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_716_1589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43408 16.6322L14.393 8.2431L17.2788 8.60784L20.9683 3.13672V20.6443H3.43408V16.6322Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_716_1589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6897 10.4316H12.2011V13.5319H16.5116C16.1098 15.5015 14.4294 16.6322 12.2011 16.6322C9.57094 16.6322 7.45222 14.5167 7.45222 11.8905C7.45222 9.26439 9.57094 7.14889 12.2011 7.14889C13.3335 7.14889 14.3563 7.55011 15.16 8.20665L17.4979 5.87229C16.0732 4.63217 14.2467 3.86621 12.2011 3.86621C7.74446 3.86621 4.16455 7.44068 4.16455 11.8905C4.16455 16.3404 7.74446 19.9148 12.2011 19.9148C16.2193 19.9148 19.8723 16.9969 19.8723 11.8905C19.8723 11.4164 19.7993 10.9057 19.6897 10.4316Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_716_1589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.968 20.6444L9.6438 11.8906L8.18262 10.7963L20.968 7.14893V20.6444Z",
    fill: "#4285F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_716_1589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.b845a635b6d1e170f960791e40aa0bb3.svg";
export { ForwardRef as ReactComponent };